import * as React from "react"
import { useGoToSignInHome } from "src/frontend/components/Public/LogIn/Glow/useGoToSignInHome"
import { usePasswordReset } from "src/frontend/components/Public/LogIn/Glow/usePasswordReset"
import { useOnboardingContext } from "src/frontend/components/Public/Onboarding/OnboardingContext"
import { Email, EmailNotification } from "src/frontend/components/Shared/Glow/EmailNotification"
import { useChromeAlerts } from "src/frontend/hooks/useChromeAlerts"
import { useDisableFor } from "src/frontend/hooks/useDisableFor"

export const PasswordResetSent: React.FC = () => {
  const {
    state: { loading, emailAddress },
  } = useOnboardingContext()
  const { onClick, disabled } = useHandlePasswordReset()
  const goHome = useGoToSignInHome()

  return (
    <EmailNotification onBack={goHome} onClick={onClick} disabled={loading || disabled}>
      If there is an account associated with <Email>{emailAddress}</Email>, you will receive an
      email with a link to reset your password.
    </EmailNotification>
  )
}

function useHandlePasswordReset() {
  const { alertSuccess } = useChromeAlerts()
  const { disabled, disableForDuration } = useDisableFor(5000)
  const onResetCompleted = React.useCallback(() => {
    alertSuccess("Please check your email!")
  }, [alertSuccess])
  const onClick = usePasswordReset(onResetCompleted, disableForDuration)

  return React.useMemo(
    () => ({
      disabled,
      onClick,
    }),
    [disabled, onClick]
  )
}
